"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Paper = _interopRequireDefault(require("../../components/Paper"));
var _excluded = ["viewBox"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? '0 0 697 697' : _props$viewBox,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], Object.assign({
    variant: 'contained',
    color: 'octopwn',
    elevation: 0,
    size: 'none',
    style: {
      backgroundColor: 'transparent'
    }
  }, rest, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox,
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#filter0_f_233_7229)"
  }, /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "-4.55302e-06",
    cy: "4.55301e-06",
    rx: "297",
    ry: "297",
    transform: "rotate(-180 -4.55302e-06 4.55301e-06)",
    fillOpacity: "0.15",
    style: {
      fill: 'var(--octopwn-paper-background-color)'
    }
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
    id: "filter0_f_233_7229",
    x: "-697",
    y: "-697",
    width: "1394",
    height: "1394",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    stdDeviation: "200",
    result: "effect1_foregroundBlur_233_7229"
  })))));
});